module.exports = __webpack_public_path__ + "static/media/bg8.33323df4.jpeg";